export const LOGO_URL = "/logo.png";

export const mockCategories = [
  {
    id: "baklava",
    title: "Baklava",
    image:
      "https://images.unsplash.com/photo-1519676867240-f03562e64548?auto=format&fit=crop&w=600&q=80",
    items: [
      {
        id: "b1",
        title: "Fıstıklı Baklava",
        description: "Geleneksel antep fıstıklı, çıtır yufkalı klasik baklava.",
        price: "6.50 €",
        image:
          "https://images.unsplash.com/photo-1519676867240-f03562e64548?auto=format&fit=crop&w=600&q=80",
      },
      {
        id: "b2",
        title: "Kuru Baklava",
        description: "Daha az şerbetli, yoğun fıstıklı lezzet.",
        price: "7.00 €",
        image:
          "https://images.unsplash.com/photo-1519676867240-f03562e64548?auto=format&fit=crop&w=600&q=80",
      },
    ],
  },
  {
    id: "kadayif",
    title: "Kadayıf",
    image:
      "https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&w=600&q=80",
    items: [
      {
        id: "k1",
        title: "Fıstıklı Kadayıf",
        description: "Taze kadayıf hamuru ve bol fıstık dolgusu.",
        price: "6.00 €",
        image:
          "https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&w=600&q=80",
      },
    ],
  },
  {
    id: "spezial",
    title: "Spezialitäten",
    image:
      "https://images.unsplash.com/photo-1587314168485-3236d6710814?auto=format&fit=crop&w=600&q=80",
    items: [
      {
        id: "s1",
        title: "Fıstıklı Burma",
        description: "Kusursuz fıstık lezzeti ve çıtır yufka deneyimi.",
        price: "7.50 €",
        image:
          "https://images.unsplash.com/photo-1587314168485-3236d6710814?auto=format&fit=crop&w=600&q=80",
      },
    ],
  },
  {
    id: "getraenke",
    title: "Getränke",
    image:
      "https://images.unsplash.com/photo-1517256064527-09c73fc73e38?auto=format&fit=crop&w=600&q=80",
    items: [
      {
        id: "g1",
        title: "Türkischer Tee",
        description: "Taze demlenmiş geleneksel çay.",
        price: "2.50 €",
        image:
          "https://images.unsplash.com/photo-1517256064527-09c73fc73e38?auto=format&fit=crop&w=600&q=80",
      },
      {
        id: "g2",
        title: "Türkischer Kaffee",
        description: "Közde pişirilmiş bol köpüklü kahve.",
        price: "3.50 €",
        image:
          "https://images.unsplash.com/photo-1517256064527-09c73fc73e38?auto=format&fit=crop&w=600&q=80",
      },
    ],
  },
];
